export default __webpack_public_path__ + "static/media/bannerImgDenied.e69e8607.png";